/** [count] bars of 0..1 from the waveform (one byte per 100 ms), by peak per bar. */
export function barsOf(waveform: Uint8Array | undefined, count: number): number[] {
  if (!waveform || waveform.length === 0) return Array.from({ length: count }, () => 0.15);
  const bars: number[] = [];
  for (let i = 0; i < count; i++) {
    const from = Math.floor((i * waveform.length) / count);
    const to = Math.max(from + 1, Math.floor(((i + 1) * waveform.length) / count));
    let peak = 0;
    for (let j = from; j < to && j < waveform.length; j++) peak = Math.max(peak, waveform[j]!);
    bars.push(peak / 255);
  }
  return bars;
}
